<template>
  <loader v-if="isLoading == true" name="spinning" loadingText="Cargando..." textColor="#ffffff" textSize="20" textWeight="500" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" :disableScrolling="true"></loader>
    
   

    <h3 style="text-align: left;">Información General</h3>
    
    <div>
        <div class="py-3 col-md-12 row">
            <div class="col-md-4">
                <label for="">Nombre</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.nombre"/>
                <label class="is-invalid">{{ validation.nombre }}</label>
            </div>
            <div class="col-md-4">
                <label for="">Email</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.email"/>
                <label class="is-invalid">{{ validation.email }}</label>
            </div>
            <div class="col-md-4">
                <label for="">Telefono</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.telefono"/>
                <label class="is-invalid">{{ validation.telefono }}</label>
            </div>
        </div>
    </div>
    <hr>
    <button type="button" v-if="existeInformacion == false" class="btn" style="background-color: #F49315; color: white;" @click="guardar">Guardar informacion de persona que recibe certificado</button>
    <button type="button" v-if="existeInformacion == true" class="btn btn-warning" @click="actualizar">Actualizar informacion de persona que recibe certificado</button>

    </template>
    <script>
    import axios from 'axios';
    import Swal from 'sweetalert2';
    export default {
        data() {
            return {
                isButton1Disabled: false,
                isButton2Disabled: true,
                form:{
                    nombre:"",
                    email:"",
                    telefono:"",
                    usuario:''
                },
                validation:{
                    nombre:"",
                    email:"",
                    telefono:""
                },
                existeInformacion:false,
                isLoading:false
            }  
        },
        created() {
            this.consultar();
        },
        methods: {
            guardar() {
                var idcotizacion = localStorage.getItem('idcotizacion');
                var usuario = localStorage.getItem('email');

                this.form.idcotizacion = idcotizacion;
                this.form.usuario = usuario;

                axios.post(this.$rutaServer+'personaRecibeCertificado', this.form)
                .then(response => {
                    if (response.status == 201) {
                        Swal.fire('¡Éxito!', 'Datos registrados', 'success');
                        this.validation.nombre = '';
                        this.validation.email = '';
                        this.validation.telefono = '';
                    }
          })
          .catch(error => {
            if(error.response.data.errors?.nombre?.[0]){
                        this.validation.nombre = error.response.data.errors?.nombre?.[0];
                    }
                    if(error.response.data.errors?.email?.[0]){
                        this.validation.email = error.response.data.errors?.email?.[0];
                    }
                    if(error.response.data.errors?.telefono?.[0]){
                        this.validation.telefono = error.response.data.errors?.telefono?.[0];
                    }
          });
            },
            actualizar() {
                var idcotizacion = localStorage.getItem('idcotizacion');
                var usuario = localStorage.getItem('email');

                this.form.idcotizacion = idcotizacion;
                this.form.usuario = usuario;

                axios.post(this.$rutaServer+'actualizarRecibeCertificado', this.form)
                .then(response => {
                    if (response.status == 200) {
                        Swal.fire('¡Éxito!', 'Datos actualizados', 'success');
                        this.validation.nombre = '';
                        this.validation.email = '';
                        this.validation.telefono = '';
                        this.consultar();
                    }
                })
                .catch(error => {
                    if(error.response.data.errors?.nombre?.[0]){
                                this.validation.nombre = error.response.data.errors?.nombre?.[0];
                            }
                            if(error.response.data.errors?.email?.[0]){
                                this.validation.email = error.response.data.errors?.email?.[0];
                            }
                            if(error.response.data.errors?.telefono?.[0]){
                                this.validation.telefono = error.response.data.errors?.telefono?.[0];
                            }
                });
            },
            consultar(){
                this.isLoading = true;
                var idcotizacion = localStorage.getItem('idcotizacion');
                
                axios.post(this.$rutaServer+'consultarPersonaRecibeCertificado',{idcotizacion:idcotizacion} )
                .then(response => {
                    if (response.status == 200) {
                        this.isLoading = false;
                        if(response.data.length > 0){
                            this.existeInformacion = true;
                        }
                        this.form.nombre = response.data[0].nombre;
                        this.form.email = response.data[0].email;
                        this.form.telefono = response.data[0].telefono;
                    }
                })
                .catch(error => {
                    
                });
            }
        },
            
    };
    </script>